'use client';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import EmailForm from './comp/EmailForm';
import getLocal from '@/app/utils/getLocal';

const SMSForm = dynamic(() => import('./comp/SMSForm'), {
    ssr: false,
    loading: () => <div>Loading...</div>,
});

export default function FooterEmailA({ theme = '', needEmailAgree }: { theme: string; needEmailAgree?: boolean }) {
    const { locale = 'us' } = getLocal();
    const [emailSubscription, setEmailSubscription] = useState('');
    const [smsSuccess, setSmsSuccess] = useState('');

    return (
        <>
            {emailSubscription && !smsSuccess ? (
                <SMSForm locale={locale} email={emailSubscription} theme={theme} setSmsSuccess={setSmsSuccess} />
            ) : (
                <EmailForm
                    locale={locale}
                    needEmailAgree={needEmailAgree}
                    setEmailSubscription={setEmailSubscription}
                    smsSuccess={smsSuccess}
                    setSmsSuccess={setSmsSuccess}
                />
            )}
        </>
    );
}
